const enum OrderType {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  WeightAsc = 'weightAsc',
  WeightDesc = 'weightDesc',
  CreatedAsc = 'createdAsc',
  CreatedDesc = 'createdDesc',
}

export default OrderType;
